export default "__VITE_ASSET__FW$Pzc0h__"